import { setAlertNotification } from "actions/Notification";
import SweetAlert from "react-bootstrap-sweetalert";
import { useSelector } from "react-redux";
import { useAlert } from "utils/notification/Notification";
import { translator } from "utils/Translator";

export const AlertNotification = () => {
  const { translate } = useSelector(({ i18n }) => i18n);
  const { alertNotification } = useSelector(({ notification }) => notification);
  const alert = useAlert();
  if (!alertNotification) {
    return <></>;
  }
  const { type, msg, title, onSubmit, onClose } = alertNotification;
  const titleMsg = title ? title : type == "success" ? translator(translate.ISA_Success, "สำเร็จ") : translator(translate.ISA_Sorry, "ขออภัย");
  const handleOnClose = async () => {
    try {
      if (onClose) {
        onClose();
      }
      alert.close();
    } catch (err) {
      console.error(err);
      alert.close();
    }
  };
  return (
    <>
      <SweetAlert
        show={true}
        error={type == "error"}
        success={type == "success"}
        confirmBtnText={`${translate.ISA_Button_Ok}`}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        title={titleMsg}
        onConfirm={handleOnClose}
      >
        {msg}
      </SweetAlert>
    </>
  );
};
